import styled from "styled-components"
import { Row } from "reactstrap"

const ExerciseRowStyle = styled(Row)`
    padding: 20px 0;
`

export default ExerciseRowStyle